export default {
  groupName: 'investor-services-demo',
  appName: 'Investor Services Demo',
  baseRoute: '/dashboard/investor-services-demo',
  label: 'AdPi Investor Services Dashboard (Demo)',
  home: '/slicer',
  image: 'demo.png',
  description: 'Investor Services AdPi Dashboard (Demo)'
}



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/config/main.js